module.exports = __webpack_public_path__ + "assets/images/home_g.7867e75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/home_g.png
// module id = 735
// module chunks = 1